import React from "react";

export const StoryEntry = (props) => {
    return <span className="story-entry">{props.content}</span>;
};
